<template>
    <!--这里是旧页面-->
    <div class="wrapper wrapper-content animated fadeInRight">
        <div class="row">
            <div class="col-sm-12">
                <div class="ibox float-e-margins">
                    <div class="ibox-content">
                        <div class="row table-responsive" style="padding-bottom: 60px">
                            <div class="col-sm-12" style="margin-bottom:20px;">

                                <div class="col-sm-5" style="margin-right: 20px;">
                                    <el-input v-model="searchParams.memberNo" placeholder="Member No"
                                        name="searchName"></el-input>
                                </div>
                                <div class="col-sm-5">
                                    <el-select v-model="searchParams.status" placeholder="Search Status" clearable
                                        filterable>
                                        <el-option v-for="item in statusList" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>

                            </div>
                            <div class="search-area-bottom">
                                <div style="display: flex; " class="col-sm-12">
                                    <div v-if="userRole != 2" class="col-sm-5" style="margin-right: 20px;">
                                        <el-select v-model="searchParams.districtCode" placeholder="Search district"
                                            clearable filterable>
                                            <el-option v-for="item in districtGetlist" :key="item.districtCode"
                                                :label="item.districtNameEn" :value="item.districtCode">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="col-sm-5">
                                        <el-select v-model="searchParams.messageType" placeholder="Search Type" clearable
                                            filterable>
                                            <el-option v-for="item in messageTypeList" :key="item.value" :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-12 textRight">
                                    <div class>
                                        <el-button @click="getRequestEventList('isGoFristPage')" type="primary
                        ">{{ $t("message.Search") }}</el-button>
                                    </div>
                                </div>
                            </div>
                            <div class="search-area-bottom">
                                <div>{{ total }}{{ $t("message.datagridresult") }}</div>
                            </div>
                            <el-table :data="requestEventList" border style="width: 100%" ref="multipleTable" row-key="id"
                                class="rowss">
                                <el-table-column sortable prop="memberNo" label="Member ID" min-width="160"></el-table-column>
                                <el-table-column prop="messageType" label="Type" width="120">
                                    <template slot-scope="scope">
                                        <div>{{ messageTypeMap[scope.row.messageType] }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="generalType" label="Sub-Type" min-width="160">
                                    <template slot-scope="scope">
                                        <div>{{ generalTypeeMap[scope.row.generalType] }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="districtCode" label="District" min-width="180">
                                    <template slot-scope="scope">
                                        <div>{{ districtGetMap[scope.row.districtCode] }}</div>
                                        {{ scope.row.districtCode }}
                                    </template>
                                </el-table-column>
                                <el-table-column sortable prop="createdAt"  min-width="140" label="Created At">
                                </el-table-column>

                                <el-table-column prop="status" width="140" label="Status">
                                    <template slot-scope="scope">
                                        <div>{{ statusMap[scope.row.status] }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Action" width="120" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="primary" style="
                          background-color: #409eff;
                          border-color: #409eff;
                          width: 95px;
                        " size="mini" @click="handleToDetail(scope.row)">view</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-col :span="24" class="el-table_footertoolbar">
                                <el-pagination layout="total, sizes, prev, pager, next, jumper"
                                    @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                    :page-sizes="[10, 20, 50, 100]" :page-size="searchParams.pageSize" :total="total"
                                    style="float: right">
                                </el-pagination>
                            </el-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import config from "../config";

export default {
    mixins: [config.globalMixin],
    data() {
        return {
            searchParams: {
                messageType: null,
                districtCode: null,
                memberNo: '',
                status: null,
                pageIndex: 1,
                pageSize: 10,
            },
            districtGetlist: [],
            total: 0,
            statusCount: [],
            requestEventList: [],
            statusSelected: null,
        };
    },
    computed: {
        userInfo() {
            return this.getAuthObj();
        },
        baseURL() {
            return config.domain + "/";
        },
        userRole() {
            const res = JSON.parse(sessionStorage.getItem("userInfo"));
            return res.roleType;
        },
        districtGetMap() {
            const res = {}
            this.districtGetlist.forEach(i => {
                res[i.districtCode] = i.districtNameEn
            })
            return res
        },
        messageTypeMap() {
            return {
                1: 'General',
                2: 'Event'
            }
        },
        messageTypeList() {
            return [
                { label: "General", value: 1 },
                { label: "Event", value: 2 },
            ]
        },
        statusMap() {
            return {
                0: "Submitted",
                1: "Closed"
            }
        },
        statusList() {
            return [
                { label: "Submitted", value: 0 },
                { label: "Closed", value: 1 },
            ]
        },
        generalTypeeMap() {
            return {
                0: "Member Login Enquiry",
                1: "Event Enquiry",
                2: "Redemption Enquiry",
                3: "Others",
            }
        }
    },
    created() { },
    mounted() {
        this.getRequestEventList();
        if(this.userRole!=2) this.getDistrictGetlist();
    },
    methods: {
        async getDistrictGetlist() {
            let obj = this.getAuthObj();
            obj.apiUrl = this.apiConfig.districtGetlist;
            let data = await this.$store.dispatch("apiEvent", obj);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.$set(this, "districtGetlist", data.data.result);
        },
        async getRequestEventList(isGoFristPage) {
            if (isGoFristPage) this.searchParams.pageIndex = 1;
            const param = {
                ...this.searchParams,
                ...this.userInfo,
                apiUrl: "/memberCommentBox/list",
            };
            let data = await this.$store.dispatch("apiEvent", param);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.requestEventList = data.data.result.memberCommentBoxList;
            this.statusCount = data.data.result.statusCount;
            this.total = data.data.result.total;
        },
        handleCurrentChange(val) {
            this.searchParams.pageIndex = val;
            this.getRequestEventList();
        },
        handleSizeChange(val) {
            this.searchParams.pageSize = val;
            this.getRequestEventList("isGoFristPage");
        },
        handleToDetail(row) {
            this.$router.push({
                path: "/main/memberCommentBoxDetail",
                query: {
                    id: row.id,
                },
            });
        }
    },
};
</script>
<style lang="scss" scoped>
.search-area-bottom {
    padding: 10px 0 3px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
</style>
  